module.exports = __webpack_public_path__ + "img/Australia.19228553.png";